import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Box from '@mui/material/Box'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Input from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import InputAdornment from '@mui/material/InputAdornment'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import DoneIcon from '@mui/icons-material/Done'
import ClearIcon from '@mui/icons-material/Clear'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    padding: 0,
  },
  input: {
    display: 'flex',
    backgroundColor: '#fff',
    padding: 0,
    '& .MuiInputBase-input': {
      borderRight: 'solid 1px #dbe3e6',
    }
  },
  addornment: {
    display: 'flex',
    padding: '0 7px 0 5px',
    justifyContent: 'center',
  },
  button: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.2)'
    },
  }
}));

export default function EditableLabel(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(props.label)
  const inputRef = React.useRef()

  React.useEffect (() => {
    setValue(props.label)
  },[props.label])

  React.useEffect(() => {
    if (props.editing) {
      setTimeout(() => {
        inputRef.current.focus()
      }, 10)
    }
  }, [props.editing])

  function handleCancel() {
    setValue(props.label)
    props.onCancel && props.onCancel()
  }

  return (
    <Box className={props.className}>
      {props.editing && (
        <ClickAwayListener onClickAway={handleCancel}>
          <FormControl
            className={classes.root}
            margin="dense"
            onClick={e => e.stopPropagation()}
          >
            <InputLabel>{props.caption}</InputLabel>
            <Input
              value={value}
              inputRef={inputRef}
              className={classes.input}
              onKeyDown={e => {
                e.key == 'Enter' && props.onConfirm(value)
                e.key == 'Escape' && handleCancel()
              }}
              onChange={e => setValue(e.target.value)}
              endAdornment={
                <InputAdornment className={classes.addornment}>
                  <span className={classes.button} onClick={() => props.onConfirm(value)}>
                    <DoneIcon />
                  </span>
                </InputAdornment>
              }
            />
          </FormControl>
        </ClickAwayListener>
      )}
      {!props.editing && (<span>{props.label}</span>)}
    </Box>
  )
}
